import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { contractOpportunityGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';

const PurchaseSingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get("id");
  const [purchaseData, setPurchaseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      contractOpportunityGet({id})
        .then(response => {
          setPurchaseData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, [])

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            <div className="single-page-wrap">
              <Link
                to={`/specific-message?id=${purchaseData.user_id}`}
                className="btnSizes filledBtn link my-2"
              >
                Contact
              </Link>
              <SinglePageItemText 
                title="Item to Purchase"
                value={purchaseData.name}
              />
              <SinglePageItemText 
                title="Item Description"
                value={purchaseData.description}
              />
               <SinglePageItemText 
                title="Quantity"
                value={purchaseData.quantity}
              />
              <SinglePageItemText 
                title="Date Required"
                value={purchaseData.required_date}
              />
              <SinglePageItemText 
                title="City"
                value={purchaseData.city}
              />
              <SinglePageItemText 
                title="State"
                value={purchaseData.state}
              />
              <SinglePageItemText 
                title="ZIP Code"
                value={purchaseData.zip}
              />
              <SinglePageItemArray 
                type="pm"
                title="Opportunity Classification"
                value={purchaseData.setaside_code}
              />
              <SinglePageItemText 
                title="Primary NAICS"
                value={purchaseData.naics}
              />
              <SinglePageItemText 
                title="Additional Notes and Comments"
                value={purchaseData.comment}
              />
              <div className="single-page-item">
                <h4>
                  Web Address for more info:
                </h4>
                <p>
                  {purchaseData.link ? <a href={purchaseData.link} target="_blank" rel="noreferrer">{purchaseData.link}</a> : "N/A"}
                </p>
              </div>
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default PurchaseSingle;